/**
 * @module constants/index
 * @description Barrel export for all application constants
 * Exports form titles, benefit types, API endpoints, and other constants
 */

export * from './constants';
